import axios from "axios";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const listPayments = (paymentsData) => {
  return async (dispatch) => {
    // dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_PAYMENTS_LIST_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(`${BASE_URL}/payment/list`,paymentsData,config);
      if (data.statusCode === 200) {
        dispatch({ type: "GET_PAYMENTS_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_PAYMENTS_LIST_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_PAYMENTS_LIST__FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


export const listRequestPayments = (paymentsData) => {
  return async (dispatch) => {
    // dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_PAYMENTS_REQUEST_LIST_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(`${BASE_URL}/payment/request-refund-list`,paymentsData,config);
      if (data.statusCode === 200) {
        dispatch({ type: "GET_PAYMENTS_REQUEST_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_PAYMENTS_REQUEST_LIST_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_PAYMENTS_REQUEST_LIST__FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


export const viewPayment = (paymentId) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_PAYMENT_VIEW_REQUEST" });
      const { data } = await axios.get(`${BASE_URL}/payment/view/${paymentId}`);
      if (data.statusCode === 200) {
        dispatch({ type: "GET_PAYMENT_VIEW_SUCCESS", payload: data.data });
      } else {
        dispatch({ type: "GET_PAYMENT_VIEW_FAILED", payload: data.message });
      }
    } catch (error) {
      dispatch({
        type: "GET_PAYMENT_VIEW_FAILED",
        payload: error?.response?.data?.message || error.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const updateStatus = (id, statusData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "UPDATE_STATUS_REQUEST" });
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.put(`${BASE_URL}/payment/update-status/${id}`, statusData, config);
      if (data.statusCode === 200) {
        dispatch({ type: "UPDATE_STATUS_SUCCESS", payload: data });
      } else {
        dispatch({ type: "UPDATE_STATUS_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "UPDATE_STATUS_FAILED",
        payload: error?.response?.data?.message || error.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};
